// extracted by mini-css-extract-plugin
module.exports = {"content":"FooterContact_content__32gZg","btn":"FooterContact_btn__1MFQR"};